


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import { SurveyGroupingElement } from '@/models/survey-elements/grouping-element';
import WidgetWrapper from '@/components/WidgetWrapper.vue';
import { ValidationObserver } from 'vee-validate';
import { EventBus } from '@/event-bus';
import { WIDGET_EVENTS } from '@/const/widget-events';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

type EventParams = {
  field: SurveyElementsUnion;
  value: any;
  question?: number;
};
@Component({
  name: 'dynamic-form',
  components: {
    ValidationObserver,
    WidgetWrapper,
  },
})
export default class DynamicForm extends Vue {
  $refs!: Vue['$refs'] & {
    observer: InstanceType<typeof ValidationObserver>;
  };
  @Prop({ type: Array, required: true }) pageFields!: SurveyElementsUnion[];

  private created() {
    EventBus.$on(WIDGET_EVENTS.CHANGE, this.onFieldChange);
    EventBus.$on(WIDGET_EVENTS.SUBMIT, this.onFieldSubmit);
    EventBus.$on(WIDGET_EVENTS.NESTED_FIELD_CHANGE, this.onNestedFieldChange);
  }
  private beforeDestroy() {
    EventBus.$off(WIDGET_EVENTS.CHANGE, this.onFieldChange);
    EventBus.$off(WIDGET_EVENTS.SUBMIT, this.onFieldSubmit);
    EventBus.$off(WIDGET_EVENTS.NESTED_FIELD_CHANGE, this.onNestedFieldChange);
  }

  async validate(): Promise<boolean> {
    return await this.$refs.observer.validate();
  }
  private onNestedFieldChange({ field, value, question }: EventParams) {
    if (!('additionalTextAreaElements' in field)) {
      return;
    }
    const nestedField = field.additionalTextAreaElements.find(
      item => item.id === question
    );

    nestedField!.value = value;
  }
  private onFieldChange({ field, value }: EventParams) {
    field.value = value;
  }

  private onFieldSubmit({ field, value }: EventParams) {
    field.value = value;
    this.$nextTick(() => {
      this.$emit('submit', value);
    });
    return value;
  }

  @Watch('pageFields', { deep: true })
  onPageFieldsChange(current: SurveyElementsUnion[]) {
    const groupingElement = current.find(
      item => item.elementType === COMPONENT_TYPES.GROUPING_ELEMENT
    ) as SurveyGroupingElement | undefined;

    if (!groupingElement) return;

    const { elements: groupElements } = groupingElement;

    const groupingCheckBoxElement = groupElements.find(
      ({ elementType }) => elementType === COMPONENT_TYPES.CHECKBOX_ELEMENT
    );

    const hasFilledFields = groupElements.some(
      ({ isAnswerable, value }) => isAnswerable && value
    );

    groupingCheckBoxElement &&
      (groupingCheckBoxElement.isRequired = !!hasFilledFields);
  }
}
